<template>
  <v-app>
    <!-- <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Vuetify</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <span class="mr-2">Latest Release</span>
      </v-btn>
    </v-toolbar> -->
    <v-navigation-drawer temporary v-model="sideNav" app v-if="!isPrintView">
      <v-list>
        <v-list-tile 
          v-for="item in menuItems" 
          :key="item.title"
          :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile  @click="onSignout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Signout</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="primary" dark app v-if="!isPrintView">
      <v-toolbar-side-icon 
        @click="sideNav = !sideNav"
        class="hidden-sm-and-up"></v-toolbar-side-icon>
      <v-toolbar-title class="hidden-xs-only">
        <img src="@/assets/hmark_logo_compressed2.png" alt="Healthmark" width="200" height="50" border="0" class="mainLogo" >
        <!-- <img src="@/assets/Logo20240221.png" alt="Healthmark" width="185" height="34" border="0" class="mainLogo" > -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="display-1 white--text ">
        {{title}}
      </v-toolbar-title>
      <!-- <v-spacer></v-spacer> -->
      <!-- <div class="headline">Quotation</div> -->
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat 
        v-for="item in menuItems" 
        :key="item.title"
        :to="item.link">        
          <v-icon left >{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-xs-only" v-if="loggedIn">
        <v-btn flat @click.prevent="onSignout">        
          <v-icon left>exit_to_app</v-icon>
          Signout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <div class="">
        <router-view></router-view>
      </div>
    </v-content>
    <v-footer app v-if="!isPrintView">
      <v-layout row class="text-xs-right body-2">
        <v-flex xs8 md4 text-xs-left pl-3>{{loginInfo}}</v-flex>
        <v-flex hidden-sm-and-down pr-3>
          © 2026, Healthmark Industries Company, Inc.
          (ver. {{version}})
        </v-flex>
        <v-flex xs4 hidden-md-and-up pr-3 style="white-space: nowrap;">
          v. {{version}}
        </v-flex>
      </v-layout>
    </v-footer>
    <v-layout row justify-center>
      <v-dialog v-model="showLoading" persistent content content-class="centered-dialog">
        <v-container fill-height>
          <v-layout column justify-center align-center>
            <v-progress-circular indeterminate :size="70" :width="7" color="purple"></v-progress-circular>
            <!-- <h1 v-if="message != null">{{message}}</h1> -->
            <h1>Processing...</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>

  </v-app>
</template>

<script>
// import Vue from 'vue'

// import HelloWorld from './components/HelloWorld'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data () {
    return {
      sideNav: false,

    }
  },
    computed: {
      ...mapGetters('auth', [
        'loggedIn',
        'userData',
        'userHasPublicRole',
        'userHasInternalRole',
        'userHasSysAdminRole',
        'mfaEnabled',
      ]),
      port() {
        return location.port
      },
      version () {
        return process.env.VUE_APP_VERSION
      },
      title () {
        return process.env.VUE_APP_TITLE
      },
      showLoading () {
        return this.$store.getters.loading
      },
      loginInfo () {
        if (this.loggedIn) {
          return `Welcome, ${this.userData.fullName}`
        }
      },
      menuItems () {
        let menuItems = [
          {icon: 'lock_open', title: 'Sign in', link: '/login'}
        ]
        if (this.loggedIn) {
          if(this.userHasInternalRole) {
          // console.log('user has int role')
            menuItems = [
              {icon: 'home', title: 'Home', link: '/'}
              // {icon: 'home', title: 'Home', link: '/int-quotes'}
              // {icon: 'note_add', title: 'Add Job', link: '/new_job'}
            ]
          }
          if(this.userHasPublicRole) {
          // console.log('user has ext role')
            menuItems = [
              {icon: 'home', title: 'Home', link: '/'}
              // {icon: 'assignment', title: 'Quotes', link: '/pub-quotes'}
              // {icon: 'note_add', title: 'Add Job', link: '/new_job'}
            ]
          }
          if (this.userHasSysAdminRole) { //this.$store.getters.userHasSysAdminRole) {
            menuItems.push({icon: 'settings', title: 'Settings', link: '/admin/settings'})
          }
          // Only show My Account when at least one MFA method is enabled in Web.config —
          // the page only holds MFA management, so a no-MFA deployment hides it entirely.
          if (this.mfaEnabled) {
            menuItems.push({icon: 'person', title: 'My Account', link: '/my-account'})
          }
        }
        return menuItems
      },
      isPrintView () {
        return this.$route.query.isPrintView
      }
    },
    created () {
      if (this.loggedIn) {
        this.loadMfaConfig()
      }
    },
    methods: {
      ...mapActions('auth',[
        'logout',
        'loadMfaConfig'
      ]),
      onSignout () {
        // console.log('signout called')
        // this.$store.dispatch('signUserOut')
        this.logout()
      }
    },
    watch: {
        loggedIn (value) {
            if (!value) {
                this.$router.push('/')
            } else {
                this.loadMfaConfig()
            }
        }
    }
}
</script>
<style lang="stylus">
  @import '~vuetify/src/stylus/main' // Ensure you are using stylus-loader

.application.theme--light {
    background: white
}

.rotate {
    text-align: center;
    vertical-align: middle;
    width: 20px;
    margin: 0px;
    padding: 0px;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    white-space: nowrap;
    -webkit-transform: rotate(-90deg); 
    -moz-transform: rotate(-90deg); 
}
.inputRaw {
    width:95%;
    border-bottom:1px solid;
}
.inputNum {
  text-align: right
}
.pagebreak { 
  page-break-before: always; 
}
.dialog.centered-dialog,
.v-dialog.centered-dialog
{
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: whitesmoke;
}
</style>